// @flow

export const wait = (ms: number): any =>
  new Promise((resolve, reject) => setTimeout(resolve, ms));
